export default __webpack_public_path__ + "static/media/correct6.a9e5306d.mp3";